import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
import { neutral } from '../../../../style/colors';
export const List = (props: IconPropType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      onClick={onClick ? () => onClick() : () => { }}
      style={style}
      width={width ? width : height ? height * (21 / 21) : 21}
      height={height ? height : width ? width * (21 / 21) : 21}
      viewBox="0 0 18 17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.44 2.22h-7.32v-.84c0-.3-.25-.56-.56-.56H8.44c-.31 0-.56.25-.56.56v.84H.55c-.3 0-.56.26-.56.57v.56c0 .3.25.56.56.56h7.31v.85c0 .3.26.56.57.56h1.12c.31 0 .56-.25.56-.56V3.9h7.32c.3 0 .56-.25.56-.56v-.56c0-.31-.25-.57-.56-.57zm0 11.25H5.62v-.84c0-.3-.25-.56-.56-.56H3.94c-.31 0-.56.25-.56.56v.84H.56c-.3 0-.56.26-.56.57v.56c0 .3.25.56.56.56h2.81v.85c0 .3.26.56.57.56h1.12c.31 0 .57-.25.57-.56v-.85h11.8c.32 0 .57-.25.57-.56v-.56c0-.31-.25-.57-.56-.57zm0-5.62h-2.82v-.84c0-.31-.25-.57-.56-.57h-1.12c-.31 0-.56.26-.56.57v.84H.55c-.3 0-.56.25-.56.56v.56c0 .31.25.57.56.57h11.81v.84c0 .31.26.56.57.56h1.12c.31 0 .56-.25.56-.56v-.84h2.82c.3 0 .56-.26.56-.57v-.56c0-.3-.25-.56-.56-.56z"
        fill={color ? color : neutral[700]}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default List;

